import React from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';

const ListaExigencias = (props) => {
  if (!props.exigencias || props.exigencias.length === 0) {
    return null;
  }
  const montaExigencia = (exigencia, index) => {
    if (exigencia.comentario) {
      return (
        <React.Fragment>
          <p><b>{index + 1} - {exigencia.acao}</b></p>
          <p><b>Comentário:</b> {exigencia.comentario}</p>
        </React.Fragment>
      );
    }
    return (<p><b>{index + 1} - {exigencia.acao}</b></p>);
  };
  // Vinicius
  const listaExigenciasFiltradas = props.exigencias
    .filter(exigencia => (exigencia.atributo || exigencia.tipo === 10 || exigencia.tipo === 11));
  // const listaExigenciasFiltradas = props.exigencias.filter(exigencia => exigencia.atributo);
  const listaExigencias = listaExigenciasFiltradas.map((exigencia, index) => (
    montaExigencia(exigencia, index)
  ));
  return (
    <DtpAccordionGroup>
      <DtpAccordionPanel
        headingId="exigencias"
        panelId="lista-exigencias"
        icon="ico-alert"
        title="Exigências"
      >
        {listaExigencias}
      </DtpAccordionPanel>
    </DtpAccordionGroup>
  );
};
ListaExigencias.propTypes = {
  // Conteúdo exibido no corpo do modal
  exigencias: PropTypes.arrayOf(PropTypes.shape({
    codigo: PropTypes.number,
    acao: PropTypes.string,
  })).isRequired,
};
export default ListaExigencias;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/ListaExigencias.jsx